export { default as Login } from './Login';
export { default as PatientLogin } from './PatientLogin';
export { default as ReportVerification } from './ReportVerification';
export { default as CriticalAcknowledgement } from './CriticalAcknowledgement';
export { default as ViewProfile } from './ViewProfile';
export { default as PeerReview } from './PeerReview';
export * from './superadmin';
export * from './admin';
export * from './analytics';
